import { gql } from '@apollo/client'

// Copied from src/query/processing-activity.ts (GET_ALL_PROCESSES) and adapted per the
// packaging-processing-activities FE spec §3: type-filtered `where`, search narrowed to
// activityName/processFlow, node selection reordered/pruned for the packaging column set.
export const GET_ALL_PACKAGING_PROCESSES = gql`
  query AllPackagingProcesses(
    $str: String
    $secondaryDataReferenceSourceType: NullableOfReferenceSourceTypeEnumOperationFilterInput
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [ProcessingActivitiesGraphQlSortInput!]
  ) {
    secondaryDataReferenceSourceType: __type(name: "ReferenceSourceTypeEnum") {
      name
      enumValues {
        name
        description
      }
    }
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    processingActivity: __type(name: "ProcessingActivitiesGraphQl") {
      fields {
        name
        description
      }
    }

    packagingProcessingActivities(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        type: { eq: Packaging }
        or: [
          { activityName: { contains: $str } }
          { processFlow: { contains: $str } }
          { secondaryDataReferenceSourceType: $secondaryDataReferenceSourceType }
          { state: $state }
        ]
      }
      order: $order
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          code
          state
          type
          isEndOfLife
          activityName
          processFlow
          additionalSupplementaryInformation
          defaultMaterialLossFactor
          totalProductAndWasteWeight
          secondaryDataReferenceSourceType
          dataQualityReliabilityScore
          dataQualityCompletenessScore
          referencesSamplingYear
          referenceDataPublicationYear
          referenceSourcingCountry
          referenceCountryISOCode
          referenceRegionIdentifier
          referenceTechnologyType
          referenceTechnologyProxyContribution
          dataQualityComment
          lastPublishedDate
          researcherName
          isVerified
          verifiedOn
          lastUpdatedName
          updated
        }
        cursor
      }
    }
  }
`
